import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import Echo from '../plugins/echo/echo';
import { BaseInfoActions } from '../Reducer/BaseInfoReducer';
import { showInAppNoti } from '../Reducer/InAppNotiReducer';
import {
  handlePermitNotification,
  handleWorkStopNotification,
  scheduleLocalNotification,
} from '../Components/Util/fcmHelpers';
import { BackInfoActions } from '../Reducer/BackInfoReducer';
import { useNavigate } from 'react-router-dom';
import { CommonActions } from '../Reducer/CommonReducer';
import { isPermitDetailFcmTitle } from '../Scripts/PermitNew/M_PER_NEW/utils/permitNavUtils';

export const useFcmReceiver = (Search3) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { fcmReceptionPayload, userInfo } = useSelector((s) => s.BaseInfo);

  const handleRouting = (data) => {
    if (!data) return;
    if (!userInfo || Object.keys(userInfo).length === 0) return;

    const title = String(data.title ?? '').trim();
    const responseData = data.responseData ?? '';
    const route = data.route ?? '';

    console.log('[FCM] handleRouting', { title, responseData, route });

    if (title === '작업중지') {
      const isManager =
        userInfo.authCd === 'HEAD_MANAGER' ||
        userInfo.authCd === 'BUSINESS_OWNER';
      const url = isManager
        ? `/M_WorkStop/detail/${responseData}`
        : `/M_WorkStop/${responseData}`;

      dispatch(BackInfoActions.clear());
      dispatch(
        BackInfoActions.push({ id: 'root_home', type: 'page', path: '/Home' })
      );
      navigate(url, { replace: true });
      dispatch(BaseInfoActions.setFcmReceptionPayload({}));
      return;
    }

    if (isPermitDetailFcmTitle(title)) {
      if (!responseData) {
        console.warn('[FCM] 작업허가서 dailyCd 없음', data);
        return;
      }

      dispatch(BackInfoActions.clear());
      dispatch(
        BackInfoActions.push({ id: 'root_home', type: 'page', path: '/Home' })
      );
      dispatch(CommonActions.increaseStep());
      navigate(`/M_Permit/detail/${responseData}`, { replace: true });
      dispatch(BaseInfoActions.setFcmReceptionPayload({}));
      return;
    }

    if (!route) return;

    dispatch(BackInfoActions.clear());
    dispatch(
      BackInfoActions.push({ id: 'root_home', type: 'page', path: '/Home' })
    );
    navigate(route, { replace: true });
    dispatch(BaseInfoActions.setFcmReceptionPayload({}));
  };

  useEffect(() => {
    if (!fcmReceptionPayload || fcmReceptionPayload.isClicked) return;

    const data = fcmReceptionPayload.data;
    if (!data) return;

    const title =
      data.title || fcmReceptionPayload.notification?.title || '';
    const body = data.body || fcmReceptionPayload.notification?.body || '';
    const { responseData, gubun } = data;

    console.log('[FCM] foreground', { title, responseData, gubun, data });

    dispatch(
      showInAppNoti({
        gubun,
        responseData,
        body,
        title,
      })
    );

    handlePermitNotification(dispatch, body);
    handleWorkStopNotification(dispatch, title, body, responseData, Search3);
  }, [fcmReceptionPayload, userInfo]);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const androidListener = Echo.addListener('fcmMessage', async (data) => {
      dispatch(
        BaseInfoActions.setFcmReceptionPayload({ data, isClicked: false })
      );
      await scheduleLocalNotification(data.title, data.body);
    });

    const iosListener = PushNotifications.addListener(
      'pushNotificationReceived',
      (notification) => {
        const data = notification.data;
        dispatch(
          BaseInfoActions.setFcmReceptionPayload({ data, isClicked: false })
        );
      }
    );

    const actionListener = PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification) => {
        const data = notification.notification?.data;
        if (data) {
          dispatch(
            BaseInfoActions.setFcmReceptionPayload({ data, isClicked: true })
          );
        }
      }
    );

    return () => {
      androidListener.remove();
      iosListener.remove();
      actionListener.remove();
    };
  }, []);

  useEffect(() => {
    if (fcmReceptionPayload?.isClicked) {
      handleRouting(fcmReceptionPayload.data);
    }
  }, [fcmReceptionPayload, userInfo]);
};
